import { render, staticRenderFns } from "./CanteenList.vue?vue&type=template&id=6a374cc6&"
import script from "./CanteenList.vue?vue&type=script&lang=js&"
export * from "./CanteenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports